export const GET_DOMAINS = "GET_DOMAINS"
export const GET_DOMAINS_SUCCESS = "GET_DOMAINS_SUCCESS"
export const GET_DOMAINS_FAIL = "GET_DOMAINS_FAIL"

export const GET_DOMAIN = "GET_DOMAIN"
export const GET_DOMAIN_SUCCESS = "GET_DOMAIN_SUCCESS"
export const GET_DOMAIN_FAIL = "GET_DOMAIN_FAIL"

export const SHOW_DELETE_MODAL = "SHOW_DELETE_MODAL";
export const HIDE_DELETE_MODAL = "HIDE_DELETE_MODAL";

export const DELETE_DOMAIN = "DELETE_DOMAIN";
export const DELETE_DOMAIN_SUCCESS = "DELETE_DOMAIN_SUCCESS"
export const DELETE_DOMAIN_FAIL = "DELETE_DOMAIN_FAIL"

export const CREATE_DOMAIN = "CREATE_DOMAIN";
export const CREATE_DOMAIN_SUCCESS = "CREATE_DOMAIN_SUCCESS"
export const CREATE_DOMAIN_FAIL = "CREATE_DOMAIN_FAIL"

export const UPDATE_DOMAIN = "UPDATE_DOMAIN";
export const UPDATE_DOMAIN_SUCCESS = "UPDATE_DOMAIN_SUCCESS"
export const UPDATE_DOMAIN_FAIL = "UPDATE_DOMAIN_FAIL"